export default __webpack_public_path__ + "static/media/eyeicon.6c31ed65.svg";